//import { CaseStudiesTransition } from './transitions/case-studies-transition';
import { DefaultTransition } from './transitions/default-transition';
import { FadeOutTransition } from './transitions/fade-out-transition';
//import { FadeInTransition } from './transitions/fade-in-transition';
//import { CaseStudiesFiltersTransition } from './transitions/case-studies-filters-transition';

import Barba from 'barba.js';

export default function (routes) {

  let linkClicked = '';

  // Blacklist all WordPress Links (e.g. for adminbar)
  function addBlacklistClass() {
      $( 'a' ).each( function() {
          if ( this.href.indexOf('/wp-admin/') !== -1 ||
              this.href.indexOf('/wp-login.php') !== -1 ) {
              $( this ).addClass( 'no-barba' ).addClass( 'wp-link' );
          }
      });
  }
  addBlacklistClass();

  // Fire Barba.js
  Barba.Pjax.start();
  Barba.Prefetch.init();

  /******************************************************
   * Set specific transitions for links clicked
   ******************************************************/
  Barba.Pjax.getTransition = function() {
    if( $(linkClicked).hasClass('next-up__panel') ) {
      //return CaseStudiesTransition;
    }
    if( $(linkClicked).hasClass('close-button') ) {
      return FadeOutTransition;
    }
    if( $(linkClicked).hasClass('tile') ) {
      return DefaultTransition;
    }
    /*
    if( $(linkClicked).hasClass('sub-navigation__link') ) {
      return CaseStudiesFiltersTransition;
    }
    */
    return DefaultTransition;
  };

  Barba.Dispatcher.on('linkClicked', (link) => {
    linkClicked = link;
  });


  Barba.Dispatcher.on('transitionCompleted', function() {

    // Set new classes from #af-classes to body
    $('body').attr('class', $('#body-classes').attr('class'));
    $('#body-classes').remove();
    $('#barba-wrapper').removeClass('transitioning');
    $('meta[name="theme-color"]').attr('theme-color', $('body').css('background-color'));

      if(window.video) {
        window.video.destroy();
      }
      // Fire routes again after new content loaded
      routes.loadEvents();

      /**
       * Trigger loaderfinished event
       */
      $(window).trigger('loaderFinished');

      /**
       * Trigger pageLoadedEvent event
       */
      var pageLoadedEvent = document.createEvent('Event');
      pageLoadedEvent.initEvent('pageLoaded', true, true);
      window.dispatchEvent(pageLoadedEvent);

      if( $('[data-video-mute]').length ) {
        $('[data-video-mute]').trigger('click');
      }



  });

}



// WEBPACK FOOTER //
// ./scripts/page-to-page-transitions.js